import React from "react"

// ==================== ANIMATED NOTEFORGE LOGO ====================
export const NoteForgeLogoSVG = ({ animate = true, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  }
  
  return (
    <div className={`relative ${animate ? 'logo-pulse' : ''}`}>
      <svg className={`${sizeClasses[size]} relative z-10`} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="noteforgeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
          <filter id="noteforgeGlow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <rect x="5" y="10" width="90" height="75" rx="18" fill="url(#noteforgeGradient)" filter="url(#noteforgeGlow)" />
        <path d="M15 80 L15 90 L30 80" fill="url(#noteforgeGradient)" />
        {/* Sound bars with subtle animation */}
        <rect x="20" y="35" width="5" height="30" rx="2.5" fill="white" opacity="0.95">
          {animate && <animate attributeName="height" values="30;22;30" dur="1s" repeatCount="indefinite" />}
          {animate && <animate attributeName="y" values="35;39;35" dur="1s" repeatCount="indefinite" />}
        </rect>
        <rect x="30" y="25" width="5" height="50" rx="2.5" fill="white" opacity="0.95">
          {animate && <animate attributeName="height" values="50;38;50" dur="0.8s" repeatCount="indefinite" />}
          {animate && <animate attributeName="y" values="25;31;25" dur="0.8s" repeatCount="indefinite" />}
        </rect>
        <rect x="40" y="40" width="5" height="20" rx="2.5" fill="white" opacity="0.95">
          {animate && <animate attributeName="height" values="20;30;20" dur="0.9s" repeatCount="indefinite" />}
          {animate && <animate attributeName="y" values="40;35;40" dur="0.9s" repeatCount="indefinite" />}
        </rect>
        {/* N letter */}
        <path d="M55 25 L55 75 M55 25 L80 75 M80 25 L80 75" stroke="white" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    </div>
  )
}

// ==================== PAYPAL OFFICIAL ICON ====================
export const PayPalIcon = ({ size = 'md', animate = true }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
  }
  
  return (
    <div className={`relative ${animate ? 'logo-float' : ''}`}>
      <svg className={`${sizeClasses[size]} relative z-10`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106z" fill="#003087"/>
        <path d="M21.222 6.917a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z" fill="#0070BA"/>
        <path d="M9.38 7.652a1.12 1.12 0 0 1 1.11-.946h6.234c.739 0 1.428.048 2.058.142.17.025.337.054.502.086a8.27 8.27 0 0 1 .843.19c.217.057.425.122.627.192a6.594 6.594 0 0 1 1.666.632c.352-2.256.002-3.793-1.224-5.185C19.686.942 17.268.287 14.13.287H4.753a1.336 1.336 0 0 0-1.321 1.132L-.39 25.794a.803.803 0 0 0 .793.93h5.778l1.454-9.227L9.38 7.652z" fill="#003087"/>
      </svg>
    </div>
  )
}

// ==================== PAYPAL LOGO (FULL) ====================
export const PayPalLogo = ({ animate = true }) => (
  <div className={`relative ${animate ? 'logo-float' : ''}`}>
    <svg className="w-20 h-6" viewBox="0 0 101 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.237 9.466h-4.5a.625.625 0 0 0-.617.527L5.23 22.074a.375.375 0 0 0 .37.433h2.152a.625.625 0 0 0 .617-.527l.506-3.213a.625.625 0 0 1 .618-.527h1.426c2.969 0 4.682-1.436 5.128-4.282.2-1.245.008-2.223-.57-2.908-.636-.753-1.763-1.151-3.24-1.151l.01-.433zm.52 4.218c-.246 1.616-1.48 1.616-2.674 1.616h-.68l.477-3.017a.375.375 0 0 1 .37-.317h.312c.813 0 1.58 0 1.976.463.237.278.31.69.22 1.255zM26.863 13.613h-2.16a.375.375 0 0 0-.37.317l-.095.604-.151-.219c-.468-.678-1.51-.905-2.55-.905-2.385 0-4.422 1.807-4.82 4.341-.206 1.264.087 2.473.803 3.316.658.775 1.598 1.098 2.718 1.098 1.922 0 2.988-1.236 2.988-1.236l-.096.6a.375.375 0 0 0 .37.433h1.944a.625.625 0 0 0 .617-.527l1.167-7.39a.375.375 0 0 0-.37-.432h.005zm-3.008 4.203c-.208 1.232-1.187 2.06-2.435 2.06-.626 0-1.127-.201-1.45-.582-.318-.378-.44-.916-.338-1.516.195-1.223 1.189-2.076 2.418-2.076.613 0 1.11.203 1.44.588.328.388.458.93.365 1.526zM37.906 13.613h-2.17a.625.625 0 0 0-.518.274l-2.991 4.405-1.267-4.235a.627.627 0 0 0-.6-.444h-2.132a.375.375 0 0 0-.356.497l2.388 7.012-2.247 3.17a.375.375 0 0 0 .307.593h2.168a.625.625 0 0 0 .515-.27l7.21-10.408a.375.375 0 0 0-.307-.594z" fill="#003087"/>
      <path d="M45.56 9.466h-4.5a.625.625 0 0 0-.618.527l-1.89 12.081a.375.375 0 0 0 .37.433h2.313a.437.437 0 0 0 .432-.369l.537-3.371a.625.625 0 0 1 .617-.527h1.426c2.97 0 4.683-1.436 5.129-4.282.2-1.245.007-2.223-.571-2.908-.636-.753-1.762-1.151-3.239-1.151l-.006-.433zm.52 4.218c-.246 1.616-1.48 1.616-2.674 1.616h-.68l.477-3.017a.375.375 0 0 1 .37-.317h.311c.813 0 1.58 0 1.977.463.236.278.308.69.22 1.255zM60.186 13.613h-2.159a.375.375 0 0 0-.37.317l-.095.604-.152-.219c-.467-.678-1.509-.905-2.55-.905-2.384 0-4.421 1.807-4.82 4.341-.206 1.264.088 2.473.804 3.316.658.775 1.597 1.098 2.717 1.098 1.922 0 2.989-1.236 2.989-1.236l-.096.6a.375.375 0 0 0 .37.433h1.944a.625.625 0 0 0 .618-.527l1.166-7.39a.375.375 0 0 0-.37-.432h.004zm-3.007 4.203c-.208 1.232-1.187 2.06-2.435 2.06-.627 0-1.128-.201-1.45-.582-.32-.378-.44-.916-.339-1.516.195-1.223 1.189-2.076 2.418-2.076.613 0 1.11.203 1.44.588.328.388.458.93.366 1.526zM68.136 9.8l-1.92 12.274a.375.375 0 0 0 .37.433h1.86a.625.625 0 0 0 .617-.527l1.892-12.081a.375.375 0 0 0-.37-.433h-2.08a.375.375 0 0 0-.37.334z" fill="#0070BA"/>
    </svg>
  </div>
)

// ==================== ANIMATED BACKGROUND ====================
export const AnimatedBackground = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none">
    {/* Background is now transparent to allow page gradient to show */}
    
    {/* Subtle floating orbs */}
    <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-gradient-to-br from-violet-100/40 to-indigo-100/30 rounded-full blur-3xl animate-float-slow" />
    <div className="absolute top-1/3 -left-24 w-[400px] h-[400px] bg-gradient-to-br from-blue-100/30 to-cyan-100/20 rounded-full blur-3xl animate-float-delayed" />
    <div className="absolute -bottom-32 left-1/3 w-[450px] h-[450px] bg-gradient-to-br from-indigo-100/30 to-purple-100/20 rounded-full blur-3xl animate-float-slow" />
    
    {/* Refined grid pattern */}
    <div 
      className="absolute inset-0 opacity-[0.015]"
      style={{
        backgroundImage: `linear-gradient(#6366f1 1px, transparent 1px), linear-gradient(90deg, #6366f1 1px, transparent 1px)`,
        backgroundSize: '64px 64px'
      }}
    />
    
  </div>
)

// ==================== GLASS CARD COMPONENT ====================
export const GlassCard = ({ children, className = '', variant = 'default', ...props }) => {
  const variants = {
    default: 'bg-white/80 backdrop-blur-2xl border border-white/60 shadow-xl',
    elevated: 'bg-white/90 backdrop-blur-2xl border border-white/70 shadow-2xl',
    subtle: 'bg-white/60 backdrop-blur-xl border border-white/40 shadow-lg',
  }
  
  return (
    <div 
      className={`rounded-2xl ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

// ==================== LOADING SPINNER ====================
export const LoadingSpinner = ({ size = 'lg' }) => {
  const sizes = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
  }
  
  return (
    <div className={`relative ${sizes[size]}`}>
      {/* Background circle */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-slate-50 to-slate-100" />
      
      {/* Static track */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="42" fill="none" stroke="#e5e7eb" strokeWidth="3" />
      </svg>
      
      {/* Animated spinner */}
      <svg className="absolute inset-0 w-full h-full animate-spin-slow" viewBox="0 0 100 100">
        <defs>
          <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
        </defs>
        <circle 
          cx="50" cy="50" r="42" 
          fill="none" 
          stroke="url(#spinnerGradient)" 
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="80 200"
        />
      </svg>
      
      {/* Center PayPal PP Logo */}
      <div className="absolute inset-0 flex items-center justify-center">
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Back P */}
          <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106z" fill="#003087"/>
          {/* Front P */}
          <path d="M23.048 7.667c-.028.179-.06.362-.096.55-1.237 6.351-5.469 8.545-10.874 8.545H9.326c-.661 0-1.218.48-1.321 1.132L6.596 26.83l-.399 2.533a.704.704 0 0 0 .695.814h4.881c.578 0 1.069-.42 1.16-.99l.048-.248.919-5.832.059-.32c.09-.572.582-.992 1.16-.992h.73c4.729 0 8.431-1.92 9.513-7.476.452-2.321.218-4.259-.978-5.622a4.667 4.667 0 0 0-1.336-1.03z" fill="#0070BA"/>
          {/* Overlay for depth */}
          <path d="M21.754 7.151a9.757 9.757 0 0 0-1.203-.267 15.284 15.284 0 0 0-2.426-.177H11.89a1.12 1.12 0 0 0-1.11.946l-1.347 8.541-.039.245a1.336 1.336 0 0 1 1.321-1.132h2.752c5.405 0 9.637-2.195 10.874-8.545.037-.188.068-.371.096-.55a6.594 6.594 0 0 0-1.017-.429 9.045 9.045 0 0 0-1.666-.632z" fill="#003087"/>
        </svg>
      </div>
    </div>
  )
}

// ==================== STATUS BADGE ====================
export const StatusBadge = ({ status, pulse = false }) => {
  const statusConfig = {
    processing: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Processing' },
    success: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Verified' },
    error: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Error' },
  }
  
  const config = statusConfig[status] || statusConfig.processing
  
  return (
    <div className={`inline-flex items-center gap-2 ${config.bg} px-3 py-1.5 rounded-full`}>
      <div className="relative flex items-center justify-center">
        <div className={`w-2 h-2 ${config.dot} rounded-full`} />
        {pulse && (
          <div className={`absolute w-2 h-2 ${config.dot} rounded-full animate-ping`} />
        )}
      </div>
      <span className={`text-xs font-semibold ${config.text}`}>{config.label}</span>
    </div>
  )
}

// ==================== BUTTON COMPONENT ====================
export const Button = ({ children, variant = 'primary', size = 'md', className = '', ...props }) => {
  const variants = {
    primary: 'bg-gradient-to-r from-violet-600 to-indigo-600 text-white shadow-lg shadow-violet-500/25 hover:shadow-xl hover:shadow-violet-500/30 hover:from-violet-700 hover:to-indigo-700 active:scale-[0.98]',
    secondary: 'bg-slate-100 text-slate-700 hover:bg-slate-200 active:scale-[0.98]',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 active:scale-[0.98]',
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
  }
  
  return (
    <button
      className={`
        relative overflow-hidden font-semibold rounded-xl
        transition-all duration-200 ease-out
        focus:outline-none focus:ring-2 focus:ring-violet-500/50 focus:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {/* Shine effect for primary */}
      {variant === 'primary' && (
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
      )}
      <span className="relative z-10 flex items-center justify-center gap-2">
        {children}
      </span>
    </button>
  )
}
